import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from "react";
import DatoImage from "~components/dato-image";
import { Box, Heading, LinkBox, LinkOverlay, Stack, Tag, Text, useColorModeValue, Wrap, WrapItem } from "@chakra-ui/react";
import format from "date-fns/format";
import Link from "next/link";
var PostItem = /*#__PURE__*/React.forwardRef(function PostItem(props, ref) {
  var href = props.href,
      post = props.post,
      rest = _objectWithoutProperties(props, ["href", "post"]);

  var bgColor = useColorModeValue("whiteAlpha.50", "whiteAlpha.50");
  var Wrapper = href ? LinkBox : Box;
  return /*#__PURE__*/_jsxs(Wrapper, _objectSpread(_objectSpread({
    _hover: {
      bgColor: "whiteAlpha.200",
      boxShadow: "lg",
      translateY: "-4px"
    },
    bgColor: bgColor,
    borderRadius: "md",
    boxShadow: "sm",
    overflow: "hidden",
    role: "group",
    transform: "auto-gpu",
    transitionDuration: "fast",
    transitionProperty: "common",
    transitionTimingFunction: "ease-out",
    w: "full"
  }, rest), {}, {
    ref: ref,
    children: [post.cover && /*#__PURE__*/_jsx(Box, {
      bgColor: "whiteAlpha.800",
      maxH: ["3xs", "2xs"],
      overflow: "hidden",
      children: /*#__PURE__*/_jsx(DatoImage, {
        data: post.cover.responsiveImage
      })
    }), /*#__PURE__*/_jsxs(Stack, {
      align: "center",
      direction: "column",
      p: [4, 8],
      children: [/*#__PURE__*/_jsx(Text, {
        color: "whiteAlpha.700",
        fontSize: "sm",
        children: format(new Date(post._publishedAt), "PPPP")
      }), href ? /*#__PURE__*/_jsx(LinkOverlay, {
        href: href,
        children: /*#__PURE__*/_jsx(Heading, {
          size: "lg",
          children: post.title
        })
      }) : /*#__PURE__*/_jsx(Heading, {
        size: "lg",
        children: post.title
      }), /*#__PURE__*/_jsx(Text, {
        color: "whiteAlpha.600",
        fontStyle: "italic",
        pb: 4,
        children: post.subtitle
      }), /*#__PURE__*/_jsx(Wrap, {
        justify: "center",
        children: post.tags.map(function (t) {
          return /*#__PURE__*/_jsx(WrapItem, {
            children: /*#__PURE__*/_jsx(Link, {
              href: "/tag/".concat(t.slug),
              passHref: true,
              children: /*#__PURE__*/_jsx(Tag, {
                as: "a",
                size: "sm",
                variant: "subtle",
                children: t.title
              })
            })
          }, t.slug);
        })
      })]
    })]
  }));
});
export default PostItem;